import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.entries";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { callbackAmountSplitManageAdd, callbackAmountSplitManageUpd } from "@/api/financial/backhaul";
import { serchSelect } from "@/mixins/index";
export default {
  mixins: [serchSelect],
  props: {
    callbackSwitchConfigData: {
      type: Array,
      data: function data() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        switch_id: '',
        amountJson: []
      },
      rules: {
        switch_id: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        amountJson: [{
          required: true,
          message: "请添加拆分条件",
          trigger: "blur"
        }],
        totalAmount: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }, {
          pattern: /^[1-9]\d*$/,
          message: '请输入正整数',
          trigger: 'blur'
        }],
        value: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }, {
          pattern: /^[1-9]\d*$/,
          message: '请输入正整数',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    console.log("callbackSwitchConfigData", this.callbackSwitchConfigData);
  },
  methods: {
    init: function init(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, amount_json, amountJson;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (row) {
                  data = row;
                  amount_json = JSON.parse(data.amount_json);
                  amountJson = Object.entries(amount_json).map(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2),
                        totalAmount = _ref2[0],
                        amountsStr = _ref2[1];

                    var amountList = amountsStr ? amountsStr.map(function (a) {
                      return {
                        value: a
                      };
                    }) : [];
                    return {
                      totalAmount: parseInt(totalAmount),
                      amountList: amountList
                    };
                  });
                  _this.formData.amountJson = _toConsumableArray(amountJson);
                  _this.formData.id = data.id;
                  _this.formData.switch_id = data.switch_id;
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addContent: function addContent() {
      this.formData.amountJson.push({
        totalAmount: '',
        amountList: []
      });
    },
    addAmountItem: function addAmountItem(domain) {
      domain.amountList.push({
        value: ""
      });
    },
    removeItemContent: function removeItemContent(item, itemList) {
      var idx = itemList.indexOf(item);

      if (idx !== -1) {
        itemList.splice(idx, 1);
      }
    },
    removeContent: function removeContent(item) {
      var index = this.formData.amountJson.indexOf(item);

      if (index !== -1) {
        this.formData.amountJson.splice(index, 1);
      }
    },
    resetForm: function resetForm(formName) {
      this.formData.id = '';
      this.dialogFormVisible = false;
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.formData));
          var amount_json = {};
          data.amountJson && data.amountJson.forEach(function (item) {
            var amount = [];

            if (item.amountList.length) {
              amount = item.amountList.map(function (a) {
                return a.value;
              });
            }

            amount_json[item.totalAmount] = amount.length ? amount : "";
          });
          var params = {
            switch_id: data.switch_id,
            amount_json: amount_json,
            id: data.id
          };
          var req = data.id ? callbackAmountSplitManageUpd : callbackAmountSplitManageAdd;
          req(params).then(function (res) {
            if (res.status == 200) {
              _this2.$Message.success('操作成功');

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      var _this3 = this;

      this.formData = {
        id: this.formData.id,
        switch_id: '',
        amountJson: []
      };
      this.$nextTick(function () {
        _this3.$refs.ruleForm.resetFields();
      });
    }
  }
};